
export type AttachmentType = typeof AttachmentType[keyof typeof AttachmentType];


export const AttachmentType = {
  BusinessLicense: 'BusinessLicense',
  Contract: 'Contract',
  VATCertificate: 'VATCertificate',
  RegisteredNationalAddress: 'RegisteredNationalAddress',
  CommercialRegistration: 'CommercialRegistration',
} as const;
